import { RoleType } from '~/graphql/generated/graphql';

export const SCHOOL_ACCOUNT_ROLE_LABEL_KEYS: Record<RoleType, string> = {
  [RoleType.Teacher]: 'schools.auth.chooseAccount.roles.teacher',
  [RoleType.Student]: 'schools.auth.chooseAccount.roles.student',
  [RoleType.Admin]: 'schools.auth.chooseAccount.roles.admin',
};

/** The server already orders the accounts; a personal classroom sits apart, after the schools. */
export const groupSchoolAccountChoices = <Choice extends { isPersonal: boolean }>(choices: Choice[]) => [
  { key: 'schools', isPersonal: false, choices: choices.filter(choice => !choice.isPersonal) },
  { key: 'personal', isPersonal: true, choices: choices.filter(choice => choice.isPersonal) },
].filter(section => section.choices.length > 0);
